const BROWSER_HISTORY = {
  declineOffer: { back_restrict: true },
  authLock: { back_restrict: true },
  bankDetailsConfirm: { back_restrict: true },
  agreement: { back_restrict: true },
  congrat: { back_restrict: true },
  underReview: { back_restrict: false }
};
let isCompleted = false;
export const getBrowserHistory=(pathname)=>{
  if(pathname){
    let urls =pathname.split("/");
    let browserHistory = BROWSER_HISTORY[urls[urls.length-1]];
    return browserHistory?browserHistory:false;
  }
  return false;
};

export const browserBackEventHandler=(nextProps, props)=>{
  BROWSER_HISTORY.underReview.back_restrict= (props.xsell_data && props.xsell_data.documentUploaded);
  const browserRestriction = getBrowserHistory(props.location.pathname);
  if(props.history.action === "POP" && browserRestriction.back_restrict){
    nextProps.location.pathname = props.location.pathname;
    props.history.push(props.location.pathname);
  }else if(props.xsell_data.lockedBrowserBack && browserRestriction === false){
    isBrowserLocked(true);
  }

  const notifyBrowserRestrict = getBrowserHistory(nextProps.location.pathname);
  if(notifyBrowserRestrict.back_restrict && !(props.xsell_data.lockedBrowserBack)){
    if(isCompleted === false){
      props.restrictBrowserBackProcess();
      isCompleted = true;
    }

  }
};

export const isBrowserLocked=(props)=>{
  const browserRestriction = getBrowserHistory(location.pathname);
  if(props.xsell_data && props.xsell_data.lockedBrowserBack && browserRestriction === false){
    window.location.assign('/clapply/cl/CLError.action');
  }
};
